import { createDeepEqualSelector } from '@mb/lib';
import { useSelector } from 'react-redux';

import { SnackbarInfoState } from '../slices/snackbarInfoSlice';

interface State {
  snackbarInfo: SnackbarInfoState;
}

export const commonSelector = (state: State) => state.snackbarInfo;

export const snackbarInfoSelector = createDeepEqualSelector(
  commonSelector,
  (common) => common.snackbarInfo,
);

export const useSnackbarInfo = () => {
  return useSelector(snackbarInfoSelector);
};
